import { DIALOG_DATA, DialogModule, DialogRef } from '@angular/cdk/dialog';
import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ButtonConfig, Job, Referral } from '@interfaces';
import { GtagService } from 'src/app/containers/gtag/gtag.service';
import { calculateButtonClasses } from 'src/app/helpers/buttons';
import { ReferralsService } from 'src/app/rest/referrals.service';
import { DialogContainerComponent } from '../../dialog-container/dialog-container.component';

@Component({
    selector: 'app-referral-form',
    templateUrl: './referral-form.component.html',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, DialogContainerComponent, DialogModule],
})
export class ReferralFormComponent {
    public referForm: UntypedFormGroup;
    public job: Job;
    public referral: Referral;
    public submitted = false;
    public submitting = false;
    public error = false;
    public applyButtonConfig: ButtonConfig = {
        textColour: "text-white",
        background: {
            type: "custom",
            value: "bg-blue-500",
        },
        textSize: "regular",
    };
	public applyButtonClasses = calculateButtonClasses(this.applyButtonConfig);
   
    constructor(
        public dialogRef: DialogRef<boolean>,
        private fb: UntypedFormBuilder,
        private gtag: GtagService,
        @Inject(ReferralsService) private referralsService: ReferralsService,
        @Inject(DIALOG_DATA) public data: any
    ) {
        this.job = data.job;
        const formConfig = {
            creator: this.fb.group({
                name: ['', Validators.required],
                email: ['', [Validators.required, Validators.email]]
            }),
            referees: [],
        };
        this.referForm = this.fb.group(formConfig);
    }

    async apply() {
        this.submitting = true;
        const payload: Referral = {
            ...this.referForm.value,
            referees: this.referForm.value.referees.split(',')?.map((referee) => referee.trim()),
            job: this.job._id,
            employer: this.job.employer,
        };
        try {
            const result = await this.referralsService.post(payload).toPromise();
            this.gtag.fireReferralEvent(this.job._id, this.job.title);
            this.referral = (result as Referral);
            this.submitted = true;
            this.submitting = false;
        } catch (error) {
            this.error = true;
            this.submitting = false;
        }
    }

    getJobLink(code) {
        return `${this.job.permalink}?referral=${code}`;
    }

    public copyToClipboard(code) {
        let selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = this.getJobLink(code);
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
        alert($localize`Link copied`);
        return false;
    }

    public closeDialog() {
        this.dialogRef.close();
    }

}
